import React from "react";
import { FormattedMessage } from "react-intl";
import { Flex, Center, Divider, Link, Text, Stack, StackDivider, Box } from "@chakra-ui/react";

import * as env from "env";
import { TiliaLogo } from "components/Logos";

export const IFrameFooterWithLogo = ({ includeTosAndPrivacy = false }) => (
  <Flex align="center" my={2} direction="column">
    <Divider mb={4} />
    <TiliaLogo size="sm" />
    {includeTosAndPrivacy && (
      <Box mt={2} color="tertiaryText">
        <Link href={env.TILIA_TOS_URL} isExternal fontSize="xs">
          <FormattedMessage defaultMessage="TERMS OF SERVICE" description="link" />
        </Link>
        &nbsp;&#xb7;&nbsp;
        <Link href={env.TILIA_PRIVACY_URL} isExternal fontSize="xs">
          <FormattedMessage defaultMessage="PRIVACY POLICY" description="link" />
        </Link>
      </Box>
    )}
  </Flex>
);

export const Footer = () => {
  return (
    <Center as="footer" flexDirection="column" pb={4}>
      <Divider mb={4} />
      <Flex
        py={4}
        flexDirection="column"
        align="stretch"
        w="100%"
        maxW={{ base: "lg", md: "100vw" }}
      >
        <Stack
          spacing={4}
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="center"
          my={2}
          divider={<StackDivider />}
        >
          <Link href={env.TILIA_TOS_URL} isExternal color="secondaryText" fontSize="sm">
            <FormattedMessage defaultMessage="TERMS OF SERVICE" description="link" />
          </Link>
          <Link href={env.TILIA_PRIVACY_URL} isExternal color="secondaryText" fontSize="sm">
            <FormattedMessage defaultMessage="PRIVACY POLICY" description="link" />
          </Link>
          <Link href={env.TILIA_SUPPORT_URL} isExternal color="secondaryText" fontSize="sm">
            <FormattedMessage defaultMessage="CONSUMER COMPLAINT INFORMATION" description="link" />
          </Link>
        </Stack>

        <Center>
          <Text color="secondaryText" mt={4} fontSize="sm">
            © {new Date().getFullYear()} Tilia LLC, All Rights Reserved
          </Text>
        </Center>
      </Flex>
    </Center>
  );
};
